import React, { forwardRef, useRef } from "react";
import { chakra, useFormControl, useFormControlContext, useMergeRefs, useMultiStyleConfig, } from "@chakra-ui/react";
import { useLocale, useNumberField } from "react-aria";
import { useNumberFieldState } from "react-stately";
export const NumberInput = forwardRef(({ isDisabled, isReadOnly, isRequired, isInvalid, formatOptions, min, max, placeholder, step, value, width = "xs", onChange, ...props }, ref) => {
    const { locale } = useLocale();
    const formControlContext = useFormControlContext();
    const formControl = useFormControl({
        isDisabled,
        isReadOnly,
        isRequired,
        isInvalid,
    });
    const sharedProps = {
        isDisabled: formControl.disabled,
        isReadOnly: formControl.readOnly,
        isRequired: formControl.required,
        "aria-labelledby": formControlContext?.labelId,
        "aria-describedby": formControlContext?.helpTextId,
        id: formControlContext?.id,
        formatOptions,
        minValue: min,
        maxValue: max,
        placeholder,
        step,
        value,
        validationState: formControl["aria-invalid"] ? "invalid" : "valid",
        onChange,
    };
    const state = useNumberFieldState({
        ...sharedProps,
        locale,
    });
    const inputRef = useRef(null);
    const { groupProps, inputProps } = useNumberField(sharedProps, state, inputRef);
    const styles = useMultiStyleConfig("Input");
    const mergedRef = useMergeRefs(ref, inputRef);
    return (React.createElement(chakra.div, { ...groupProps, ...props },
        React.createElement(chakra.input, { ref: mergedRef, ...inputProps, width: width, maxWidth: "100%", __css: styles["field"], "data-testid": "number-input" })));
});
